import { Preset } from "@/models/Preset";

export default function getDiagnosticIdsFromPreset(preset: Preset | null): string[] {
  return preset?.columns?.map(col => col.diagnostic.id).flat() ?? [];
}
